<template>
  <div class="row h-100 flex-grow-1 no-gutters align-content-start align-content-md-stretch">
    <div class="col d-md-none mt-3 pr-3 pl-xs-3" v-if="$route.path == '/'">
      <div class="alert alert-warning">
        <b>Limited functionality on mobile</b>
        <br />Try Chrome on desktop for all features
      </div>

      <router-link class="btn-primary btn btn-block font-weight-bold when-expanded btn-lg" to="/referral/?to=_" title="Create Referral">
        <span class>Create Referral</span>
      </router-link>
    </div>
    <div class="col-12 mt-3 mt-md-0">
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  components: {},
  data() {
    return {}
  },
}
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
/*a {
      color: #42b983;
    }*/
</style>
